import React, {useEffect, useState} from 'react';
import axios from 'axios';
import dayjs from "dayjs";
import NumberFormat from "react-number-format";



const InfoBox = ({title, value,mini=false, danger=false})=><div className={`border p-2  rounded shadow-md bg-gray-100 ${danger ? 'bg-red-100' : ''}`}>
    <div className="text-gray-500 text-sm" >{title}</div>
    <div className={` ${mini?'text-lg ':'text-2xl '}`} >{value}</div>
</div>

  export default function CustomerAnalyzerPage(props) {

    const [data, setData] = useState(null);
    const [loading, setLoading]=useState(false);


    useEffect( () => {

        getData();
      }, []  )




      const getData=()=>{

        setLoading(true);
        axios.get(  process.env.REACT_APP_API_ENDPOINT + `delivery/customerAnalyzer/sospechosos` ).then(
          (result)=>{
             console.log( "result axios counter", result);
             setData(result.data);
             setLoading(false);

          }
      ).catch( e=>         setLoading(false)      );  

      }


    //   if(loading) return <div>Loading...</div>


    return (
        <div className="overflow-scroll w-full  p-5 gap-5 flex flex-col">


        <h1> Clientes marcados como sospechosos</h1>

        {/* <button
        className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
        type="button"
            onClick={()=>getData()} 
        >
            Refresh
        </button> */}

            <div className="p-2 rounded-sm bg-white">
            <table className="table-auto w-full mt-5">
            <thead>
            <tr className="bg-indigo-200">
            <th className="px-2 py-2">#</th>
            <th className="px-2 py-2">Registrado el</th>
            <th className="px-2 py-2">Nombre</th>
            <th className="px-2 py-2">Celular</th>
            <th className="px-2 py-2">Email</th>
            <th className="px-2 py-2"></th>
            </tr>
            </thead>
            <tbody>

            {
            data && data.map ((item,i)=>{


            return <tr className="bg-gray-100"  key={item.id} >
            <td className="border px-1 py-1"> { i+1 } </td>

            <td className="border px-1 py-1">  { dayjs(item.created_at).format('DD/MM/YYYY HH:mm:ss') }   </td>

            <td className="border px-1 py-1"> { item.nombre } </td>
            <td className="border px-1 py-1"> { item.celular } </td>
            <td className="border px-1 py-1"> { item.email } </td>

            <td className="border px-1 py-1"> 

                      <a 
                        className="px-3 py-1 bg-blue-200 rounded-md"  
                        href={`/customerAnalyzer/${item.id}`} >
                       Ver perfil
                    </a>
                
                 </td>


            </tr>
            }
            )
            }
            </tbody>
            </table>
            </div>




            {/* <pre>
             DATA:   {
                JSON.stringify(data, null, 2)
             }
            </pre> */}




        </div>
    )
}



